import { Class, ClassFormData } from "../../types/classes"
import { axiosInstance } from "./axios"
import { ApiResponse } from "../../types/common";

export const classService = {

    getAll: async (academicYearId?: number): Promise<Class[]> => {
        const params: Record<string, unknown> = {};
        if (academicYearId) params.AcademicYearId = academicYearId;
        const response = await axiosInstance.get<ApiResponse<Class[]>>("v1/Classes", { params });
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || 'failed to fetch');
        }
        return response.data.data;
    },
    getById: async (id: number, instituteId: number) => {
        const response = await axiosInstance.get<ApiResponse<Class>>("v1/Classes/GetClassById", { params: { ClassId: id, InstituteId: instituteId } });
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || 'failed to fetch');
        }
        return response.data.data;
    },
    create: async (data: ClassFormData, instituteId: number) => {
        const response = await axiosInstance.post<ApiResponse<number>>('v1/Classes', {
            className: data.name,
            instituteId: instituteId,
            boardTypeId: data.boardTypeId || undefined,
            academicYearId: data.academicYearId,
            sections: data.sections.map(s => ({
                sectionName: s.name,
                teacherId: s.classTeacherId === 0 ? undefined : s.classTeacherId,
                totalCapacity: s.totalCapacity
            }))
        });
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || 'failed to Add');
        }
    },

    update: async (id: number, data: ClassFormData, instituteId: number) => {
        const requestData = {
            classId: id,
            className: data.name,
            instituteId: instituteId,
            boardTypeId: data.boardTypeId || undefined,
            academicYearId: data.academicYearId,
            sections: data.sections.map(s => ({
                sectionId: s.id,
                sectionName: s.name,
                teacherId: s.classTeacherId,
                totalCapacity: s.totalCapacity
            })),
            deleteSections: data.removedSectionIds ?? []
        };
        const response = await axiosInstance.put<ApiResponse<string>>(`v1/Classes`, requestData);
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || 'failed to Update');
        }
    },
    delete: async (id: number, instituteId: number) => {
        const response = await axiosInstance.delete<ApiResponse<string>>(`v1/Classes?ClassId=${id}&InstituteId=${instituteId}`);
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || 'failed to Delete');
        }
    },

    reorder: async (instituteId: number, orders: { classId: number; displayOrder: number }[]) => {
        const response = await axiosInstance.put<ApiResponse<boolean>>('v1/Classes/reorder', {
            instituteId,
            orders,
        });
        if (!response.data.succeeded) {
            throw new Error(response.data.messages?.[0] || 'failed to reorder');
        }
    },
}